/* ==========================================================================
   Beer Rubbers — theme.js
   Vanilla, no dependencies, no framework. Replaces the app stack:
     · Biscuits Bundles  -> pack ladder + pack builder below
     · BOGOS / Secomapp  -> automatic free gift over the threshold
     · Vitals cart drawer-> the drawer below
   All catalog data comes from window.BR_DATA (see snippets/br-data.liquid),
   which is built live from Shopify products. Nothing is hardcoded.
   ========================================================================== */
(function () {
  'use strict';

  var D = window.BR_DATA;
  if (!D) return;

  var CFG = D.cfg || {};

  // Market. CUR_RATE is Shopify's own USD -> shopper-currency rate (1 for the
  // US); Shopify converts each fixed-amount discount with it and rounds to
  // the cent, which the builder below mirrors so its quote matches checkout.
  var CUR = CFG.currency || 'USD';
  var CUR_RATE = 1;
  try { CUR_RATE = parseFloat(window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) || 1; } catch (e) { CUR_RATE = 1; }
  var TIER_DISC = CFG.tierDiscounts || {};
  // Markets without a free gift (Australia) get an empty gift list from br-data.liquid.
  var HAS_GIFT = !!(D.gifts && D.gifts.length);

  // Sitewide promo unit-price display (Theme settings > Offer > Sitewide
  // discount %). Display only -- it recomputes the "$X each" shown on the
  // product page's pack list and Build a Pack's ladder, it never changes
  // what gets charged. The real discount is a separate Shopify Automatic
  // Discount; this number must be kept equal to its percentage by hand, or
  // the page shows a price checkout won't actually charge.
  var SITEWIDE_PCT = +CFG.sitewideDiscountPct || 0;
  // Shopify's own automatic-discount engine computes the discount amount as
  // floor(price * pct / 100), not round(price * pct / 100) -- confirmed live
  // against /cart.js (e.g. $54.99 * 25% discounts by $13.74, not $13.75,
  // charging $41.25). A plain round(amount * 0.75) is off by a cent from
  // what checkout actually charges, which is exactly what this file must
  // never do (see comment above). Mirror the floor here so every caller
  // gets an exact, checkout-matching integer back.
  function promoPrice(amount) { return SITEWIDE_PCT ? amount - Math.floor(amount * SITEWIDE_PCT / 100) : amount; }

  // Shopify's /cart.js line items carry no compare_at_price field at all
  // (confirmed live -- it simply isn't one of the keys on a cart item), so
  // the cart can't read a line's real MSRP off the cart API the way the
  // product page reads p.compare. BR_DATA already has every wired variant's
  // compare_at ("compare") from Liquid at page-load time, so this builds a
  // variant id -> MSRP map once from it, covering packs, single-rubber
  // colours, the PDP addon and the cart upsells -- i.e. everything that can
  // actually end up as a cart line. Used for the strikethrough price and the
  // "You save" total so both reflect the full original MSRP, not just
  // today's list price.
  var MSRP_BY_VARIANT = (function () {
    var m = {};
    function add(entry) { if (entry && entry.variant && entry.compare > 0) m[entry.variant] = entry.compare; }
    add(D.addon);
    (D.upsells || []).forEach(add);
    ['bottle', 'can'].forEach(function (fmt) {
      var f = D.formats && D.formats[fmt];
      if (!f) return;
      (f.colors || []).forEach(add);
      (f.packs || []).forEach(add);
    });
    return m;
  })();

  // Spend goals for the cart drawer's progress bar (free shipping + gift,
  // an extra % off, and so on). Editable in the theme editor via the
  // "Cart goals" section — see sections/cart-goals.liquid. Falls back to the
  // legacy single free-gift threshold if that section is somehow missing.
  var GOALS = (function () {
    var out = [];
    try {
      var node = document.getElementById('br-goals-data');
      var parsed = node ? JSON.parse(node.textContent) : [];
      out = (parsed || []).filter(function (g) { return g && g.threshold > 0; });
    } catch (e) { out = []; }
    out.sort(function (a, b) { return a.threshold - b.threshold; });
    return out;
  })();
  if (!GOALS.length) {
    GOALS = [{
      id: 'legacy', title: 'Free Shipping & Gift', threshold: CFG.threshold || 4900,
      icon: 'gift', reward_type: 'gift',
      countdown_message: 'You are {{remaining}} away from {{goal}}',
      success_message: '🎉 Free shipping and your free gift are unlocked'
    }];
  }

  // The free-gift pool still gates on ONE threshold: whichever goal is set
  // to reward type "gift" (normally the first/lowest one).
  var giftGoal = null;
  for (var _gi = 0; _gi < GOALS.length; _gi++) {
    if (GOALS[_gi].reward_type === 'gift') { giftGoal = GOALS[_gi]; break; }
  }
  var THRESHOLD = giftGoal ? giftGoal.threshold : GOALS[0].threshold;

  function fillGoalMsg(tmpl, goal, remainingCents) {
    return (tmpl || '')
      .replace(/\{\{\s*remaining\s*\}\}/g, money(remainingCents))
      .replace(/\{\{\s*goal\s*\}\}/g, esc(goal.title));
  }

  /* ----------------------------------------------------------------- utils */
  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function el(tag, cls, html) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (html != null) n.innerHTML = html;
    return n;
  }
  // Same Shopify image at another width (the address carries ?width=NNN).
  function sized(url, w) { return String(url || '').replace(/([?&]width=)\d+/, '$1' + w); }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ------------------------------------------------------- tap-to-zoom photo */
  // One full-size photo viewer for places that show a small product picture
  // (the cart add-ons). Same look and behaviour as the
  // Build a Pack colour preview: tap the photo, the backdrop or the X to close.
  // Pass a variant id to also show an "Add to cart" button under the photo.
  var Zoom = (function () {
    var node = null;
    function onKey(e) { if (e.key === 'Escape') close(); }
    function close() {
      if (!node) return;
      node.parentNode.removeChild(node);
      node = null;
      document.body.classList.remove('swzoom-open');
      document.removeEventListener('keydown', onKey);
    }
    function open(o) {
      close();
      node = el('div', 'swzoom');
      node.setAttribute('role', 'dialog');
      node.setAttribute('aria-label', o.name || 'Product photo');
      node.innerHTML =
        '<div class="swzoom-back"></div>' +
        '<div class="swzoom-card">' +
          '<button type="button" class="swzoom-x" aria-label="Close">&times;</button>' +
          '<img src="' + esc(o.src) + '" alt="' + esc(o.name) + '">' +
          '<div class="nm">' + esc(o.name) + '</div>' +
          (o.price ? '<div class="swzoom-pr">' + o.price + '</div>' : '') +
          (o.variant ? '<button type="button" class="swzoom-add" data-add-variant="' + o.variant + '">Add to cart</button>' : '') +
        '</div>';
      document.body.appendChild(node);
      document.body.classList.add('swzoom-open');
      node.addEventListener('click', close);
      document.addEventListener('keydown', onKey);
    }
    return { open: open, close: close };
  })();

  // A product/pack page can carry a hidden buyform (and its own accelerated
  // checkout button) per format/colour/tier. Shopify's payment button boots
  // itself, and re-fetches its own assets, the moment it lands in the live
  // DOM, so rendering all of them at once was booting 10-15 payment widgets
  // for variants nobody had picked yet. main-product.liquid keeps every
  // inactive one inert inside a <template>; this clones it into the real DOM
  // the first (and only the first) time that exact form is actually shown.
  function hydratePaymentButton(wrap) {
    var tpl = wrap && wrap.querySelector('template[data-pay-tpl]');
    if (!tpl) return;
    tpl.replaceWith(tpl.content.cloneNode(true));
  }

  // Honour the shop's money format rather than assuming dollars.
  function money(cents) {
    var fmt = CFG.moneyFormat || '${{amount}}';
    var n = (cents || 0) / 100;
    function withCommas(v, dec) {
      var parts = v.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return parts.join('.');
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, name) {
      switch (name) {
        case 'amount_no_decimals': return withCommas(n, 0);
        case 'amount_with_comma_separator': return withCommas(n, 2).replace(/,/g, '.').replace(/\.(\d{2})$/, ',$1');
        case 'amount_no_decimals_with_comma_separator': return withCommas(n, 0).replace(/,/g, '.');
        default: return withCommas(n, 2);
      }
    });
  }

  // Every variant across every gift category's pool — not just the default
  // one — so a randomly-picked sub-variant (see syncGift) is still correctly
  // recognised as the free gift line on the next render.
  function giftVariantIds() {
    var ids = [];
    (D.gifts || []).forEach(function (g) {
      var pool = (g.variants && g.variants.length) ? g.variants : [g.variant];
      pool.forEach(function (v) { if (ids.indexOf(v) === -1) ids.push(v); });
    });
    return ids;
  }
  function giftPool(g) { return (g && g.variants && g.variants.length) ? g.variants : [g ? g.variant : null]; }
  function pickRandom(arr) { return arr[Math.floor(Math.random() * arr.length)]; }
  function protectionId() { return D.protection ? D.protection.variant : null; }
  function isGiftLine(item) { return giftVariantIds().indexOf(item.variant_id) > -1; }
  function isProtectionLine(item) { return protectionId() && item.variant_id === protectionId(); }

  // Shopify's own JSON endpoints normally return JSON even on error, but a
  // proxy, a rate-limit page, or a flaky connection can hand back an HTML
  // error page instead. Parsing that as JSON throws a raw, unreadable error
  // straight at the shopper (e.g. "Unexpected token '<'"); this always
  // resolves to *something* readable instead.
  function safeJson(r) {
    return r.json().catch(function () {
      throw new Error('Something went wrong. Please try again in a moment.');
    });
  }

  /* ----------------------------------------------------------------- toast */
  // Replaces native alert() for cart/add errors: same message, but it
  // doesn't block the page or look broken on mobile.
  var Toast = {
    _timer: null,
    show: function (msg, isError) {
      var t = $('#br-toast');
      if (!t) {
        t = el('div', 'toast');
        t.id = 'br-toast';
        document.body.appendChild(t);
      }
      t.textContent = msg;
      t.className = 'toast on' + (isError ? ' err' : '');
      clearTimeout(Toast._timer);
      Toast._timer = setTimeout(function () { t.className = 'toast'; }, 4200);
    }
  };

  /* ------------------------------------------------------------------ cart */
  var Cart = {
    state: { items: [], item_count: 0, total_price: 0 },
    busy: false,

    fetch: function () {
      return fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart.js' : '/cart.js', {
        headers: { 'Accept': 'application/json' }, credentials: 'same-origin'
      }).then(safeJson).then(function (c) { Cart.state = c; return c; });
    },

    add: function (lines) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ items: lines })
      }).then(function (r) {
        if (r.ok) return safeJson(r);
        return r.json().catch(function () { return null; }).then(function (e) {
          throw new Error((e && e.description) || 'That item could not be added right now. Please try again.');
        });
      }).then(function (res) {
        // Unlike change/clear/updateLines, /cart/add.js's response is only
        // the newly-added line(s) — not the full cart — so it never updates
        // Cart.state on its own. Callers chain .then(Cart.sync) expecting
        // fresh state to already be there (that's the whole point of sync
        // over refresh: no redundant fetch), so this fetch is the one case
        // where it genuinely isn't redundant.
        return Cart.fetch().then(function () { return res; });
      });
    },

    change: function (key, qty) {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(safeJson).then(function (c) { Cart.state = c; return c; });
    },

    clear: function () {
      return fetch('/cart/clear.js', { method: 'POST', headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
        .then(safeJson).then(function (c) { Cart.state = c; return c; });
    },

    // Set several lines (by variant id) in ONE request instead of a
    // change-then-add chain. Used to swap the free gift: zero the old
    // variant and add the new one atomically, so there's no window where
    // the cart is briefly missing a gift line or holding two at once.
    updateLines: function (pairs) {
      var updates = {};
      pairs.forEach(function (p) { updates[p[0]] = p[1]; });
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ updates: updates })
      }).then(safeJson).then(function (c) { Cart.state = c; return c; });
    },

    // What counts towards free shipping and the free gift. The gift itself and
    // the shipping protection line are both excluded, so neither can push an
    // order over the line on its own.
    //
    // Uses line_price, not final_line_price: for an order-wide automatic
    // discount (allocation "across", e.g. the sitewide BR25OFF promo),
    // Shopify leaves final_price/final_line_price equal to the undiscounted
    // price and puts the real post-discount amount in line_price/total_price
    // instead -- confirmed against a live cart with that discount active.
    // Using final_line_price here would qualify orders for free shipping
    // based on what they'd have paid without the promo, not what they
    // actually pay.
    qualifying: function () {
      return (Cart.state.items || []).reduce(function (s, i) {
        if (isGiftLine(i) || isProtectionLine(i)) return s;
        return s + i.line_price;
      }, 0);
    },
    unlocked: function () { return Cart.qualifying() >= THRESHOLD; },

    // The highest-tier discount-type goal the current subtotal qualifies
    // for. Applied at checkout via the ?discount= URL param, so it is a
    // real discount, not a display-only promise.
    activeDiscountCode: function () {
      var qt = Cart.qualifying();
      var code = null;
      GOALS.forEach(function (g) {
        if (g.reward_type === 'discount' && g.discount_code && qt >= g.threshold) code = g.discount_code;
      });
      return code;
    },
    savings: function () {
      return (Cart.state.items || []).reduce(function (s, i) {
        if (isGiftLine(i)) return s;
        // cart.js has no compare_at_price field on a line item -- see
        // MSRP_BY_VARIANT above. Falls back to today's list price only for
        // a line whose variant isn't in that map (nothing wired should hit
        // this, but it's a safe floor rather than a missing number).
        var cmp = i.original_price;
        var msrp = MSRP_BY_VARIANT[i.variant_id];
        if (msrp && msrp > i.price) cmp = msrp;
        // Totals, not per-unit then times quantity: line_price already is
        // this line's real post-discount total (see qualifying() above for
        // why final_line_price doesn't work here), so comparing it directly
        // against cmp * quantity avoids a second rounding step.
        return s + Math.max(0, (cmp * i.quantity) - i.line_price);
      }, 0);
    },

    findLine: function (predicate) {
      var items = Cart.state.items || [];
      for (var i = 0; i < items.length; i++) if (predicate(items[i])) return { item: items[i], index: i + 1 };
      return null;
    },

    /* The free gift is a real $0.00 product, so it needs no discount code.
       Crossing the threshold does NOT silently add one any more: the shopper
       is asked to pick their gift in a popup (like the old BOGOS flow). The
       choice persists; "no thanks" is respected. Dropping back below the
       threshold still removes the gift automatically. */
    giftChoice: function () {
      var v = null;
      try { v = localStorage.getItem('br-gift'); } catch (e) {}
      return v; // variant id string, 'none', or null (never asked)
    },
    setGiftChoice: function (v) {
      try { localStorage.setItem('br-gift', String(v)); } catch (e) {}
    },

    syncGift: function () {
      var gifts = D.gifts || [];
      if (!gifts.length) return Promise.resolve();
      var line = Cart.findLine(isGiftLine);
      var choice = Cart.giftChoice();

      if (Cart.unlocked()) {
        if (choice === 'none') {
          if (line) return Cart.updateLines([[line.item.variant_id, 0]]);
          return Promise.resolve();
        }
        if (!choice) {
          // Ask, after the current refresh settles. Never auto-add.
          if (!line) GiftModal.request();
          return Promise.resolve();
        }
        var wantedCategory = parseInt(choice, 10);
        var wantedGift = gifts.filter(function (g) { return g.variant === wantedCategory; })[0] || gifts[0];
        var pool = giftPool(wantedGift);
        // Each gift "category" can have several sub-variants (design/colour),
        // spreading wear evenly across all of them. Pick one at random when
        // the gift is first added or when the shopper switches category —
        // but leave an already-added pick alone on every later sync, or it
        // would reshuffle on its own. Swapping is ONE request: zero the old
        // variant and add the new one together, not a separate change then
        // add — fewer round trips, and no window where the swap is half-done.
        if (!line) return Cart.updateLines([[pickRandom(pool), 1]]);
        if (pool.indexOf(line.item.variant_id) === -1) {
          return Cart.updateLines([[line.item.variant_id, 0], [pickRandom(pool), 1]]);
        }
        if (line.item.quantity !== 1) return Cart.updateLines([[line.item.variant_id, 1]]);
        return Promise.resolve();
      }
      if (line) return Cart.updateLines([[line.item.variant_id, 0]]);
      return Promise.resolve();
    },

    // The shopper's explicit choice wins and persists. Until they make one,
    // the pre-checked default applies as soon as the cart has real items.
    protectionWanted: function () {
      var v = null;
      try { v = localStorage.getItem('br-protect'); } catch (e) {}
      if (v === null) return !!CFG.protectionDefault;
      return v === '1';
    },

    setProtection: function (on) {
      try { localStorage.setItem('br-protect', on ? '1' : '0'); } catch (e) {}
      return Cart.syncProtection();
    },

    syncProtection: function () {
      var pid = protectionId();
      if (!pid) return Promise.resolve();
      var line = Cart.findLine(isProtectionLine);
      var hasRealItems = (Cart.state.items || []).some(function (i) {
        return !isProtectionLine(i) && !isGiftLine(i);
      });
      var want = Cart.protectionWanted() && hasRealItems;

      if (want && !line) return Cart.updateLines([[pid, 1]]);
      if (!want && line) return Cart.updateLines([[line.item.variant_id, 0]]);
      if (want && line && line.item.quantity !== 1) return Cart.updateLines([[line.item.variant_id, 1]]);
      return Promise.resolve();
    },

    // Re-applies the gift/protection rules to whatever Cart.state already
    // holds and re-renders. No leading fetch: every caller here (change,
    // add, clear, the gift radio, the protection checkbox) already updated
    // Cart.state itself, and syncGift/syncProtection each update it again
    // in turn if they need to change anything — so this never re-fetches
    // just to read back what the caller already knows. That's the
    // difference between one round trip for a click and three or four.
    sync: function () {
      return Cart.syncGift()
        .then(Cart.syncProtection)
        .then(function () { Drawer.render(); return Cart.state; });
    },

    // For the few places that DON'T already have fresh state to hand — the
    // drawer's very first open, initial page load — fetch first, then run
    // the same sync/render pass as everything else.
    refresh: function () {
      return Cart.fetch().then(Cart.sync);
    }
  };

  /* ----------------------------------------------------------- gift popup */
  var GiftModal = {
    pending: false,

    request: function () {
      // Deduped: several cart refreshes can run in one action.
      if (GiftModal.pending || $('#br-giftmodal')) return;
      GiftModal.pending = true;
      setTimeout(GiftModal.open, 350);
    },

    open: function () {
      GiftModal.pending = false;
      if ($('#br-giftmodal') || !Cart.unlocked() || Cart.giftChoice()) return;
      var gifts = D.gifts || [];
      if (!gifts.length) return;

      var wrap = el('div', 'giftmodal', '');
      wrap.id = 'br-giftmodal';
      wrap.setAttribute('role', 'dialog');
      wrap.setAttribute('aria-modal', 'true');
      wrap.setAttribute('aria-label', 'Choose your free gift');
      var cards = gifts.map(function (g, i) {
        return '<button type="button" class="giftmodal-opt" data-gift="' + g.variant + '">' +
          (g.img ? '<img src="' + esc(g.img) + '" alt="" width="86" height="86" loading="lazy">' : '') +
          '<b>' + esc(g.title) + '</b>' +
          '<span class="giftmodal-val">' + money(g.value) + ' value · FREE</span>' +
        '</button>';
      }).join('');
      wrap.innerHTML =
        '<div class="giftmodal-back" data-gift-close></div>' +
        '<div class="giftmodal-card">' +
          '<button type="button" class="giftmodal-x" data-gift-close aria-label="Close">✕</button>' +
          '<div class="giftmodal-kicker">🎁 You unlocked a free gift</div>' +
          '<h3>Pick your freebie</h3>' +
          '<p>Your order passed ' + money(THRESHOLD) + ', so one of these ships free with it. Which one?</p>' +
          '<div class="giftmodal-grid">' + cards + '</div>' +
          '<button type="button" class="giftmodal-skip" data-gift-skip>No gift, thanks</button>' +
        '</div>';
      document.body.appendChild(wrap);
      document.body.classList.add('gift-open');

      wrap.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-gift]');
        if (opt) {
          var v = opt.getAttribute('data-gift');
          Cart.setGiftChoice(v);
          Drawer.giftChoice = parseInt(v, 10);
          GiftModal.close();
          Cart.sync().then(function () { Drawer.open(); });
          return;
        }
        if (e.target.closest('[data-gift-skip]')) {
          Cart.setGiftChoice('none');
          GiftModal.close();
          Cart.sync();
          return;
        }
        if (e.target.closest('[data-gift-close]')) GiftModal.close();
      });
    },

    close: function () {
      var m = $('#br-giftmodal');
      if (m) m.remove();
      document.body.classList.remove('gift-open');
    }
  };

  /* ---------------------------------------------------------------- drawer */
  var Drawer = {
    giftChoice: (function () {
      var v = null;
      try { v = localStorage.getItem('br-gift'); } catch (e) {}
      return v && v !== 'none' ? parseInt(v, 10) : null;
    })(),

    build: function () {
      if ($('#br-drawer')) return;
      var scrim = el('div', 'scrim'); scrim.id = 'br-scrim';
      var d = el('aside', 'drawer'); d.id = 'br-drawer';
      d.setAttribute('aria-hidden', 'true');
      d.setAttribute('role', 'dialog');
      d.setAttribute('aria-label', 'Cart');

      // Just the message line now -- no bar, no stop markers. (That visual
      // track made sense with two goals at different thresholds; with only
      // "Free Shipping & Gift" left, a bar crawling toward one single goal
      // added nothing the text didn't already say.)
      d.innerHTML =
        '<header><h3>Your Cart</h3><button type="button" aria-label="Close cart" data-close>&times;</button></header>' +
        '<div class="progress"><div class="msg" id="br-progress-msg"></div></div>' +
        '<div class="dbody" id="br-lines"></div>' +
        '<div class="dfoot" id="br-foot"></div>';
      document.body.appendChild(scrim);
      document.body.appendChild(d);
      scrim.addEventListener('click', Drawer.close);
      d.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) Drawer.close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') Drawer.close(); });
    },

    open: function () {
      Drawer.build();
      $('#br-scrim').classList.add('on');
      $('#br-drawer').classList.add('on');
      $('#br-drawer').setAttribute('aria-hidden', 'false');
      document.body.classList.add('no-scroll');
    },
    close: function () {
      var s = $('#br-scrim'), d = $('#br-drawer');
      if (s) s.classList.remove('on');
      if (d) { d.classList.remove('on'); d.setAttribute('aria-hidden', 'true'); }
      document.body.classList.remove('no-scroll');
    },

    render: function () {
      Drawer.build();
      var c = Cart.state;

      $$('[data-cart-count]').forEach(function (n) { n.textContent = c.item_count || 0; });
      $$('[data-cart-total]').forEach(function (n) { n.textContent = money(c.total_price || 0); });

      var qt = Cart.qualifying();
      var nextGoal = null;
      for (var _ngi = 0; _ngi < GOALS.length; _ngi++) {
        if (qt < GOALS[_ngi].threshold) { nextGoal = GOALS[_ngi]; break; }
      }
      $('#br-progress-msg').innerHTML = nextGoal
        ? fillGoalMsg(nextGoal.countdown_message, nextGoal, nextGoal.threshold - qt)
        : fillGoalMsg(GOALS[GOALS.length - 1].success_message, GOALS[GOALS.length - 1], 0);

      var body = $('#br-lines');
      if (!c.items || !c.items.length) {
        body.innerHTML = '<div class="empty"><p>Your Cart is empty.</p>' +
          '<a class="btn btn-p" href="' + (D.formats.bottle.url || '/collections/all') + '">Shop Beer Rubbers</a></div>';
        $('#br-foot').innerHTML = '';
        return;
      }

      function lineHtml(i, gift) {
        var img = i.image ? i.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
        var props = '';
        if (i.properties) {
          Object.keys(i.properties).forEach(function (k) {
            if (k.charAt(0) === '_' || !i.properties[k]) return;
            props += '<div class="v">' + esc(i.properties[k]) + '</div>';
          });
        }
        // The photo and title are the first things a shopper taps on a cart
        // line to double-check what's in it (Clarity logged dead clicks on
        // them), so they link to the product. The free gift has no page to
        // send anyone to.
        var linkOpen = (!gift && i.url) ? '<a href="' + esc(i.url) + '">' : '';
        var linkClose = linkOpen ? '</a>' : '';
        return '<div class="line' + (gift ? ' gift' : '') + '">' +
          linkOpen + '<img src="' + esc(img) + '" alt="" width="68" height="68">' + linkClose +
          '<div class="li-body">' +
            (gift ? '<span class="gifttag">Free gift</span>' : '') +
            '<div class="t">' + linkOpen + esc(i.product_title) + linkClose + '</div>' +
            (i.variant_title && i.variant_title !== 'Default Title' ? '<div class="v">' + esc(i.variant_title) + '</div>' : '') +
            props +
            (gift ? '' :
              '<div class="qty">' +
                '<button type="button" data-key="' + esc(i.key) + '" data-qty="' + (i.quantity - 1) + '" aria-label="Decrease">−</button>' +
                '<input type="text" inputmode="numeric" pattern="[0-9]*" class="cart-qty-input" ' +
                  'data-key="' + esc(i.key) + '" data-prev="' + i.quantity + '" value="' + i.quantity + '" aria-label="Quantity" autocomplete="off">' +
                '<button type="button" data-key="' + esc(i.key) + '" data-qty="' + (i.quantity + 1) + '" aria-label="Increase">+</button>' +
                '<button type="button" class="rm" data-key="' + esc(i.key) + '" data-qty="0">Remove</button>' +
              '</div>') +
          '</div>' +
          // line_price, not final_line_price -- see Cart.qualifying() above
          // for why: this is the figure that actually reflects an
          // order-wide automatic discount like the sitewide promo. The
          // strikethrough is the real MSRP (MSRP_BY_VARIANT, since cart.js
          // has no compare_at_price field), matching the product/shop pages
          // rather than just today's list price.
          '<div class="p">' + (gift ? 'FREE' : money(i.line_price)) +
            (function () {
              var msrp = MSRP_BY_VARIANT[i.variant_id];
              var was = (msrp && msrp > i.price) ? msrp * i.quantity : i.original_line_price;
              return was > i.line_price ? '<s>' + money(was) + '</s>' : '';
            })() +
          '</div>' +
        '</div>';
      }

      var html = '';
      var giftItem = null;
      c.items.forEach(function (i) {
        var gift = isGiftLine(i), prot = isProtectionLine(i);
        if (prot) return; // rendered as the checkbox below, not as a line
        if (gift) { giftItem = i; return; } // rendered just above its own picker, not mixed in with regular lines
        html += lineHtml(i, false);
      });

      // The free-gift line and its "pick a different one" picker are kept
      // right next to each other, so a shopper switching gifts never has to
      // scroll away from the option they just chose to see the result.
      if (giftItem) html += lineHtml(giftItem, true);

      if (Cart.unlocked() && (D.gifts || []).length > 1) {
        var currentVariant = giftItem ? giftItem.variant_id : null;
        html += '<div class="upsells"><h4>Pick your free gift</h4>';
        D.gifts.forEach(function (g) {
          var inThisCategory = currentVariant !== null && giftPool(g).indexOf(currentVariant) > -1;
          html += '<label class="up" style="cursor:pointer">' +
            '<input type="radio" name="br-gift" value="' + g.variant + '"' + (inThisCategory ? ' checked' : '') + ' style="accent-color:var(--orange)">' +
            '<img src="' + esc(g.img) + '" alt="" width="52" height="52">' +
            '<div><div class="t">' + esc(g.title) + '</div><div class="pr">free</div></div>' +
          '</label>';
        });
        html += '</div>';
      }

      var inCart = (c.items || []).map(function (i) { return i.variant_id; });
      var offer = (D.upsells || []).filter(function (u) { return inCart.indexOf(u.variant) === -1; }).slice(0, 4);
      if (offer.length) {
        html += '<div class="upsells"><h4>Goes with it</h4>';
        offer.forEach(function (u) {
          html += '<div class="up">' +
            '<button type="button" class="up-view" data-zoom-up="' + u.variant + '" aria-label="View larger photo of ' + esc(u.title) + '">' +
              '<span class="up-img"><img src="' + esc(u.img) + '" alt="" width="52" height="52">' +
              '<span class="bcard-zoom" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg></span></span>' +
              '<span class="up-txt"><span class="t">' + esc(u.title) + '</span><span class="pr">' + money(u.price) +
                (u.compare > u.price ? ' <s>' + money(u.compare) + '</s>' : '') + '</span></span>' +
            '</button>' +
            '<button type="button" data-add-variant="' + u.variant + '">Add</button></div>';
        });
        html += '</div>';
      }

      if (D.protection) {
        var on = !!Cart.findLine(isProtectionLine);
        html += '<label class="protect"><input type="checkbox" id="br-protect"' + (on ? ' checked' : '') + '>' +
          '<span><b>Shipping protection · ' + money(D.protection.price) + '</b><br>' +
          'Covers loss, theft or damage in transit. We reship free, no questions.</span></label>';
      }

      // Rebuilding innerHTML here tears down and recreates every line's
      // +/-/Remove buttons even when nothing actually changed -- e.g.
      // picking a free gift re-renders this whole block even though
      // quantities/prices didn't move. A shopper whose tap lands on one of
      // those buttons right as that happens can end up tapping a node that's
      // already been replaced, so the click does nothing. Comparing before
      // writing skips the replacement whenever the markup is byte-identical,
      // which removes that window without changing what gets rendered.
      if (body.innerHTML !== html) body.innerHTML = html;

      var saved = Cart.savings();
      var code = Cart.activeDiscountCode();
      var checkoutHref = '/checkout' + (code ? '?discount=' + encodeURIComponent(code) : '');
      var hasRealItems = c.items.some(function (i) { return !isGiftLine(i) && !isProtectionLine(i); });
      var footHtml =
        // Names the real Shopify Automatic Discount by its own title, so a
        // shopper sees exactly why the price already looks discounted
        // instead of wondering if a code still needs entering at checkout.
        (SITEWIDE_PCT ? '<p class="promo-code">✓ BR25OFF applied automatically — sitewide ' + SITEWIDE_PCT + '% OFF</p>' : '') +
        '<div class="srow"><span>Subtotal</span><span>' + money(c.total_price) + '</span></div>' +
        '<div class="srow"><span>Shipping</span><span>' + (Cart.unlocked() ? 'FREE' : (CFG.shipEstimate ? esc(CFG.shipEstimate) : 'Calculated at checkout')) + '</span></div>' +
        (saved ? '<div class="srow saved"><span>You save</span><span>' + money(saved) + '</span></div>' : '') +
        (code ? '<div class="srow saved"><span>Code applied</span><span>' + esc(code) + '</span></div>' : '') +
        '<div class="total"><span>Total' + (CUR !== 'USD' ? ' (' + esc(CUR) + ')' : '') + '</span><b>' + money(c.total_price) + '</b></div>' +
        '<a class="btn btn-p btn-lg" data-checkout href="' + esc(checkoutHref) + '">Checkout · ' + money(c.total_price) + '</a>' +
        '<div class="note">' + esc(document.body.getAttribute('data-returns') || '14-day returns') + ' · ' +
          esc(document.body.getAttribute('data-handling') || 'Ships in 1-2 business days') + '</div>' +
        (hasRealItems ? '<button type="button" class="clearcart" data-clear-cart>Clear cart</button>' : '');
      // Same reasoning as the lines body above: this is exactly where the
      // Checkout link itself lives, so a redundant rebuild here is the one
      // most directly able to eat a shopper's tap on Checkout.
      var foot = $('#br-foot');
      if (foot.innerHTML !== footHtml) foot.innerHTML = footHtml;
    }
  };

  /* ------------------------------------------------------------- delegation */
  // Shared by the +/- buttons and the editable quantity field below.
  // Ignored, not queued: a second change while one is still in flight used
  // to silently race the first (the classic "nothing happens" complaint) or
  // land on whatever the re-render put under the cursor. The dimmed/disabled
  // state is the shopper's feedback that the change landed and is in
  // progress.
  function changeQty(key, qty) {
    if (Cart.busy) return;
    Cart.busy = true;
    var lines = $('#br-lines');
    if (lines) lines.classList.add('busy');
    Cart.change(key, qty)
      .then(Cart.sync)
      .catch(function (err) { Toast.show(err.message, true); })
      .then(function () {
        Cart.busy = false;
        var l = $('#br-lines');
        if (l) l.classList.remove('busy');
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;

    if (t.closest('[data-cart-open]')) {
      e.preventDefault();
      Drawer.open();
      Cart.refresh();
      return;
    }

    var q = t.closest('[data-key]');
    if (q && q.tagName === 'BUTTON') {
      e.preventDefault();
      changeQty(q.getAttribute('data-key'), +q.getAttribute('data-qty'));
      return;
    }

    var zu = t.closest('[data-zoom-up]');
    if (zu) {
      var zv = +zu.getAttribute('data-zoom-up');
      var zi = (D.upsells || []).filter(function (x) { return x.variant === zv; })[0];
      if (zi) {
        e.preventDefault();
        Zoom.open({
          src: zi.imgLarge || zi.img, name: zi.title, variant: zi.variant,
          price: money(zi.price) + (zi.compare > zi.price ? ' <s>' + money(zi.compare) + '</s>' : '')
        });
      }
      return;
    }

    var av = t.closest('[data-add-variant]');
    if (av) {
      e.preventDefault();
      if (Cart.busy || av.disabled) return;
      Cart.busy = true;
      av.disabled = true;
      Cart.add([{ id: +av.getAttribute('data-add-variant'), quantity: 1 }])
        .then(Cart.sync)
        .catch(function (err) { Toast.show(err.message, true); })
        .then(function () { Cart.busy = false; av.disabled = false; });
      return;
    }

    if (t.closest('[data-clear-cart]')) {
      e.preventDefault();
      if (Cart.busy) return;
      if (!window.confirm('Remove everything from your cart?')) return;
      Cart.busy = true;
      var linesEl = $('#br-lines');
      if (linesEl) linesEl.classList.add('busy');
      Cart.clear()
        .then(Cart.sync)
        .catch(function (err) { Toast.show(err.message, true); })
        .then(function () {
          Cart.busy = false;
          var l = $('#br-lines');
          if (l) l.classList.remove('busy');
        });
      return;
    }

    // Shopify's checkout is a separate page that can take a few seconds to
    // arrive, and until it does nothing on screen changes -- Clarity logged
    // taps on "Checkout" that ended the session right there. Show that the
    // tap registered. Never disable the control: a form's submit button has
    // to stay enabled or its name=checkout value isn't sent.
    var co = t.closest('[data-checkout]');
    if (co) {
      if (co.classList.contains('is-loading')) { e.preventDefault(); return; }
      co.classList.add('is-loading');
      co.setAttribute('aria-busy', 'true');
      co.setAttribute('data-label', co.textContent);
      co.textContent = 'Opening secure checkout…';
      // If the browser never leaves (blocked, offline), give the button back.
      setTimeout(function () { resetCheckout(co); }, 10000);
      return;
    }

    // The free-shipping line is the thing shoppers tap to ask "how do I get
    // there" -- take them to the add-ons right below it.
    if (t.closest('.progress')) {
      var up = $('#br-lines .upsells');
      if (up) up.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }
  });

  function resetCheckout(co) {
    if (!co || !co.classList.contains('is-loading')) return;
    co.classList.remove('is-loading');
    co.removeAttribute('aria-busy');
    var label = co.getAttribute('data-label');
    if (label) co.textContent = label;
  }
  // Coming back with the browser's back button restores the page as it was
  // left, i.e. still stuck on "Opening secure checkout…".
  window.addEventListener('pageshow', function (e) {
    if (e.persisted) $$('[data-checkout].is-loading').forEach(resetCheckout);
  });

  // Swapping the gift is now one /cart/update.js request (see
  // Cart.updateLines), so this only needs to guard against a second
  // category click landing while that one request is still in flight —
  // queues one more run instead of dropping the click or racing two swaps.
  var giftSyncPending = false;
  function runGiftSync() {
    if (Cart.busy) { giftSyncPending = true; return; }
    Cart.busy = true;
    var gLines = $('#br-lines');
    if (gLines) gLines.classList.add('busy');
    Cart.sync()
      .catch(function (err) { Toast.show(err.message, true); })
      .then(function () {
        Cart.busy = false;
        var l = $('#br-lines');
        if (l) l.classList.remove('busy');
        if (giftSyncPending) { giftSyncPending = false; runGiftSync(); }
      });
  }

  document.addEventListener('change', function (e) {
    if (e.target.id === 'br-protect') {
      if (Cart.busy) { e.target.checked = !e.target.checked; return; }
      Cart.busy = true;
      var pLines = $('#br-lines');
      if (pLines) pLines.classList.add('busy');
      Cart.setProtection(e.target.checked)
        .catch(function (err) { Toast.show(err.message, true); })
        .then(function () {
          Drawer.render();
          Cart.busy = false;
          var l = $('#br-lines');
          if (l) l.classList.remove('busy');
        });
    }
    if (e.target.name === 'br-gift') {
      Drawer.giftChoice = +e.target.value;
      Cart.setGiftChoice(String(Drawer.giftChoice));
      runGiftSync();
    }
    if (e.target.classList.contains('cart-qty-input')) {
      var inp = e.target;
      var n = parseInt(inp.value.replace(/[^0-9]/g, ''), 10);
      // Invalid or out-of-range: snap back to what the line actually holds
      // rather than guess -- the next render corrects the field either way,
      // this just avoids a stray request for a typo mid-edit.
      if (isNaN(n) || n < 0 || n > 99) { inp.value = inp.getAttribute('data-prev'); return; }
      if (String(n) === inp.getAttribute('data-prev')) return;
      changeQty(inp.getAttribute('data-key'), n);
    }
  });
  // Enter commits the typed quantity immediately instead of waiting for the
  // field to lose focus, same as pressing Tab or clicking elsewhere would.
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.classList.contains('cart-qty-input')) {
      e.preventDefault();
      e.target.blur();
    }
  });

  /* -------------------------------------------- shared format (bottle/can) */
  function renderFormats(host, current, onPick) {
    if (!host) return;
    host.innerHTML = '';
    ['bottle', 'can'].forEach(function (fid) {
      var f = D.formats[fid];
      if (!f || !f.colors || !f.colors.length) return;
      var b = el('button', 'fmt' + (fid === current ? ' on' : ''));
      b.type = 'button';
      b.innerHTML = '<img src="' + esc(f.thumb) + '" alt="" width="52" height="52">' +
        '<span><span class="n">' + esc(f.name) + '</span><span class="m">' + esc(f.sub) + '</span></span>';
      b.addEventListener('click', function () {
        $$('.fmt', host).forEach(function (x) { x.classList.remove('on'); });
        b.classList.add('on');
        onPick(fid);
      });
      host.appendChild(b);
    });
  }

  /* --------------------------------------------------------- product page */
  function initProduct() {
    var root = $('[data-product-app]');
    if (!root) return;

    var startFormat = root.getAttribute('data-format') || 'bottle';
    if (!D.formats[startFormat] || !D.formats[startFormat].colors.length) startFormat = 'bottle';
    // A shopper landing on a pack product page (e.g. from a Shopping ad)
    // should see that pack selected, not the default.
    var startPack = root.getAttribute('data-start-pack') || '';
    // Server-resolved fallback (Day Drinker's 6-pack) for when nothing above
    // matched — kept separate from startPack so it can never suppress the
    // ?variant= single-colour-ad detection below (see main-product.liquid).
    var defaultPack = root.getAttribute('data-default-pack') || '';

    // Editor-picked tiers (tier blocks) replace the wired packs per format.
    var tierData = {};
    try {
      var tEl = document.getElementById('pdp-tier-data');
      if (tEl) tierData = JSON.parse(tEl.textContent) || {};
    } catch (e) { tierData = {}; }

    var F = function () { return D.formats[state.format]; };
    // The single-rubber tier is retired from this page (no more loose colour
    // picker, pick a pack instead) -- filtered out here rather than at the
    // data source, since build-a-pack's own pricing ladder still reads the
    // same window.BR_DATA packs list and still needs "single" in it.
    function packsFor(fmt) {
      var globals = ((D.formats[fmt] && D.formats[fmt].packs) || [])
        .filter(function (p) { return p.key !== 'single'; });
      var blocks = tierData[fmt] || [];
      if (blocks.length) return blocks;
      return globals;
    }
    function P() { return packsFor(state.format); }
    var state = {
      format: startFormat,
      color: null,
      pack: null,
      qty: 1,
      addon: root.getAttribute('data-addon-default') === 'true'
    };
    state.color = F().colors[0];
    // Shopping ads for a colour land with ?variant=<id>: honour it so the ad
    // and the page show the same rubber.
    try {
      var vParam = parseInt(new URLSearchParams(location.search).get('variant'), 10);
      if (vParam) {
        var match = F().colors.filter(function (c) { return c.variant === vParam; })[0];
        if (match) state.color = match;
      }
    } catch (e) {}
    var wantSingle = false;
    try { wantSingle = !!new URLSearchParams(location.search).get('variant') && !startPack; } catch (e) {}
    // Default landing pack when nothing more specific matched: Day Drinker's
    // 6-pack. Matched by the pack's own product (qty 6 + "day drinker" in its
    // url/title), not a hardcoded key like the old 'p6' — that literal key
    // stopped existing once named tier blocks (Day Drinker, Night Shift, ...)
    // replaced the plain wired packs, so it silently matched nothing and fell
    // through to "single" (first in the list) instead. Matching on the
    // product itself survives future tier renames or reordering.
    function dayDrinker6() {
      return P().filter(function (p) {
        return p.qty === 6 && ((p.url && p.url.indexOf('day-drinker') !== -1) ||
                                (p.title && /day drinker/i.test(p.title)));
      })[0];
    }
    // The Master Case (12 pack) is the "Most popular" tile and the pack the
    // page opens on, bottles and cans alike, so match on qty 12 rather than
    // a block key (tier_b12 / tier_c12 differ per format).
    function masterCase12() {
      return P().filter(function (p) { return p.qty === 12; })[0];
    }
    state.pack = P().filter(function (p) { return p.key === startPack; })[0] ||
                 (wantSingle ? P()[0] : null) ||
                 P().filter(function (p) { return p.key === defaultPack; })[0] ||
                 masterCase12() ||
                 dayDrinker6() ||
                 P().filter(function (p) { return p.qty === 6; })[0] ||
                 P().filter(function (p) { return p.key === 'p6'; })[0] || P()[0];

    var stage = $('#stage'), thumbs = $('#thumbs');
    var media = [], packIndex = {}, colorIndex = {};
    var heroVideo = root.getAttribute('data-hero-video');
    var heroPoster = root.getAttribute('data-hero-poster');

    // Merchant-added detail/scale/lifestyle shots from the theme editor.
    var extraMedia = [];
    try {
      var extraEl = document.getElementById('pdp-extra-media');
      if (extraEl) extraMedia = JSON.parse(extraEl.textContent) || [];
    } catch (e) { extraMedia = []; }

    // Per-pack lifestyle shots from the theme editor, keyed "format:packKey".
    // They win over the pack product's own gallery when both exist.
    var packMedia = {};
    try {
      var packEl = document.getElementById('pdp-pack-media');
      if (packEl) packMedia = JSON.parse(packEl.textContent) || {};
    } catch (e) { packMedia = {}; }

    function packExtras(p) {
      var custom = packMedia[state.format + ':' + p.key] || [];
      if (custom.length) return custom;
      // tier imgs already carry every individual colour shot after the main,
      // curated to match that pack (3 for a 3-pack, 12 for a 12-pack, etc.):
      // no cap here any more, so all of them show, not just the first few.
      return (p.imgs || []).slice(1);
    }

    // Warms the browser's own image cache so the stage arrows feel instant:
    // by the time a shopper starts clicking through a pack's colours, every
    // one of them has already started downloading in the background.
    var preloaded = {};
    // skipSrc: on first load the stage keeps the server-rendered photo
    // instead of re-fetching that same slide's image at a different width
    // (see the init call below); mark that URL already "preloaded" so this
    // doesn't turn around and fetch it anyway in the background.
    function preloadPack(p, skipSrc) {
      if (!p || p.key === 'single') return;
      if (skipSrc) preloaded[skipSrc] = true;
      (p.imgs || []).forEach(function (im) {
        if (!im.src || preloaded[im.src]) return;
        preloaded[im.src] = true;
        var img = new Image();
        img.src = im.src;
      });
    }

    function buildMedia() {
      media = [];
      colorIndex = {}; packIndex = {};
      // The roll-on demo video and the seasonal offer badge used to open the
      // gallery here; both were dropped so the gallery starts on real product
      // photography and the stage stays a clean image surface.
      F().colors.forEach(function (c) {
        colorIndex[c.id] = media.length;
        media.push({ type: 'img', src: c.img, thumb: c.thumb || sized(c.img, 160), label: c.name });
      });
      P().forEach(function (p) {
        if (p.key === 'single' || !p.img) return;
        packIndex[p.key] = media.length;
        var main = (p.imgs && p.imgs[0]) ? p.imgs[0].src : p.img;
        // Unlike every extra shot below, this main slide never carried its
        // own thumb, so the thumbnail rail (a 78x78 box) fell back to this
        // same full-size image and downloaded it a second time just to
        // shrink it on screen.
        var mainThumb = (p.imgs && p.imgs[0] && p.imgs[0].thumb) || sized(p.img, 160);
        media.push({ type: 'img', src: main, thumb: mainThumb, label: p.title });
        packExtras(p).forEach(function (m, i) {
          media.push({ type: 'img', src: m.src, thumb: m.thumb, label: m.label || (p.title + ' · ' + (i + 2)) });
        });
      });
      // Extra shots come last so the primary product image is always first.
      extraMedia.forEach(function (m) {
        if (m && m.src) media.push({ type: 'img', src: m.src, thumb: m.thumb, label: m.label || '' });
      });
    }

    var currentIndex = 0;
    // Thumbnail highlight, strip scroll position and arrow visibility --
    // everything showMedia() does besides actually swapping the stage photo.
    // Split out so init can sync all of this without re-downloading a photo
    // the server already sent (see the initial showMedia call below).
    function syncMediaChrome(i) {
      currentIndex = i;
      $$('.thumb', thumbs).forEach(function (t, ti) { t.classList.toggle('on', ti === i); });
      var active = $$('.thumb', thumbs)[i];
      // Scroll only the thumbnail strip itself, never the page: scrollIntoView
      // walks up to any scrolling ancestor, and once a shopper has scrolled
      // down to "Pick your pack" the gallery sits above the viewport, so
      // bringing the thumbnail "into view" meant yanking the whole page back
      // up to the gallery every time they picked a bundle.
      if (active) {
        var wrapWidth = thumbs.clientWidth;
        var target = active.offsetLeft - (wrapWidth - active.offsetWidth) / 2;
        thumbs.scrollLeft = Math.max(0, target);
      }
      var prev = $('#stage-prev'), next = $('#stage-next');
      var multi = media.length > 1;
      if (prev) prev.hidden = !multi;
      if (next) next.hidden = !multi;
    }
    function showMedia(i) {
      var m = media[i];
      if (!m) return;
      stage.innerHTML = m.type === 'video'
        ? '<video src="' + esc(m.src) + '" poster="' + esc(m.poster) + '" autoplay muted loop playsinline></video>'
        : '<img src="' + esc(m.src) + '" alt="' + esc(m.label) + '" width="900" height="900">';
      syncMediaChrome(i);
    }
    var stagePrev = $('#stage-prev'), stageNext = $('#stage-next');
    // Cycling here also covers a pack's own colour photos, so choosing a
    // bundle does not strand the shopper on a single group shot: the arrows
    // step straight through what that pack actually includes.
    if (stagePrev) stagePrev.addEventListener('click', function () { showMedia((currentIndex - 1 + media.length) % media.length); });
    if (stageNext) stageNext.addEventListener('click', function () { showMedia((currentIndex + 1) % media.length); });

    function renderThumbs() {
      thumbs.innerHTML = '';
      media.forEach(function (m, i) {
        var b = el('button', 'thumb' + (m.type === 'video' ? ' vid' : ''));
        b.type = 'button';
        b.title = m.label;
        // horizontal strip: anything past the first few is genuinely off-screen
        // and safe to defer. Earlier ones must not be lazy or they render empty.
        b.innerHTML = '<img src="' + esc(m.type === 'video' ? m.poster : (m.thumb || m.src)) + '" alt="' + esc(m.label) +
          '" loading="' + (i < 6 ? 'eager' : 'lazy') + '" width="78" height="78">';
        b.addEventListener('click', function () { showMedia(i); });
        thumbs.appendChild(b);
      });
    }

    function renderSwatches() {
      var sw = $('#swatches');
      if (!sw) return;
      sw.innerHTML = '';
      F().colors.forEach(function (c) {
        var b = el('button');
        b.type = 'button';
        b.style.background = c.hex;
        b.title = c.name;
        b.setAttribute('aria-label', c.name);
        if (!c.available) b.setAttribute('data-soldout', 'true');
        if (state.color && c.id === state.color.id) b.classList.add('on');
        b.addEventListener('click', function () {
          state.color = c;
          $$('#swatches button').forEach(function (x) { x.classList.remove('on'); });
          b.classList.add('on');
          $('#color-name').textContent = c.name + (c.available ? '' : ' · sold out');
          if (colorIndex[c.id] != null) showMedia(colorIndex[c.id]);
          paint();
        });
        sw.appendChild(b);
      });
      $('#color-name').textContent = state.color.name;
    }

    function renderTiers() {
      var tiers = $('#tiers');
      tiers.innerHTML = '';
      P().forEach(function (p) {
        var b = el('button', 'tier' + (p.key === state.pack.key ? ' on' : ''));
        b.type = 'button';
        // Sitewide promo display: every price in this row -- the tier's own
        // total, its per-unit figure, and (below) the big price tag for
        // whichever tier is selected -- runs through the same promoPrice(),
        // so a shopper never sees two different numbers for the same pack.
        var charge = Math.round(promoPrice(tierCharge(p)));
        var unitShown = SITEWIDE_PCT ? Math.round(promoPrice(p.price) / p.qty) : tierUnit(p);
        var per = p.qty > 1 ? ' · ' + money(unitShown) + ' each' : '';
        // The thumbnail rail already fetches this same photo at a proper
        // thumb size for its own strip; reuse that URL for this 52x52 icon
        // instead of pulling p.img's full 700px version a second time.
        var tierIcon = (p.imgs && p.imgs[0] && p.imgs[0].thumb) || sized(p.img, 240);
        b.innerHTML = '<span class="rad"></span>' +
          (tierIcon ? '<img class="tim" src="' + esc(tierIcon) + '" alt="" width="52" height="52" loading="lazy">' : '') +
          '<span><span class="n">' + esc(p.title) + '</span>' +
          '<span class="m">' + esc(p.note || '') + per + '</span></span>' +
          '<span class="p"><b>' + money(charge) + '</b>' +
            (p.compare > charge ? '<s>' + money(p.compare) + '</s>' : '') + '</span>' +
          (p.best ? '<span class="flag">Most popular</span>' : '');
        b.setAttribute('aria-pressed', String(p.key === state.pack.key));
        b.addEventListener('click', function () {
          // Re-tapping the tile that is already selected (Master Case is the
          // default) used to do nothing visible, which Clarity logged as dead
          // and rage clicks. The shopper's intent is "this one, please", so
          // take them to the Add to cart button instead.
          var wasSelected = state.pack && state.pack.key === p.key;
          state.pack = p;
          $$('.tier', tiers).forEach(function (x) {
            x.classList.remove('on');
            x.setAttribute('aria-pressed', 'false');
          });
          b.classList.add('on');
          b.setAttribute('aria-pressed', 'true');
          // Pop on every tap, including re-tapping the tile that is already
          // selected or one with the same price as the last (Day Drinker and
          // Night Shift are both the same price), where nothing else on the
          // page moves and the tap otherwise reads as dead.
          b.classList.remove('pop');
          void b.offsetWidth;
          b.classList.add('pop');
          // keep the main image honest: pack shot for a pack, the chosen colour
          // for the single
          var target = p.key === 'single' ? colorIndex[state.color.id] : packIndex[p.key];
          if (target != null) showMedia(target);
          preloadPack(p);
          paint();
          flashPrice();
          if (wasSelected) nudgeBuy();
        });
        tiers.appendChild(b);
      });
    }

    // Bring the Add to cart button into view (only when it is not already
    // comfortably on screen) and give it a short pulse.
    function nudgeBuy() {
      var row = $('.buyrow');
      if (!row) return;
      var r = row.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      if (r.top < 90 || r.bottom > vh - 90) row.scrollIntoView({ behavior: 'smooth', block: 'center' });
      var btn = $('.btn-lg', row);
      if (btn) {
        btn.classList.remove('nudge');
        void btn.offsetWidth;
        btn.classList.add('nudge');
      }
    }

    // A quick highlight on the price so picking a tier reads as "that
    // registered" even though the number itself is a small, easy-to-miss
    // change -- sessions showed shoppers re-tapping a tier that had, in
    // fact, already applied.
    function flashPrice() {
      var el = $('#price-now');
      if (!el) return;
      el.classList.remove('price-flash');
      void el.offsetWidth;
      el.classList.add('price-flash');
    }

    renderFormats($('#formats'), state.format, function (id) {
      state.format = id;
      // a colour can exist for bottles and not for cans, so fall back rather
      // than leaving a swatch selected that cannot ship
      var match = F().colors.filter(function (c) { return c.id === state.color.id; })[0];
      state.color = match || F().colors[0];
      // Match the equivalent pack in the new format, not just an identical
      // key -- Day Drinker's bottle and can tiers are different blocks with
      // different keys (tier_b6 / tier_c6), so a bare key match fails here
      // the same way the initial-load default used to (see dayDrinker6()
      // above): it'd silently drop to "single" on every format switch away
      // from a tier pack instead of carrying the pack forward.
      var pk = P().filter(function (p) { return p.key === state.pack.key; })[0];
      if (!pk && state.pack.qty === 6) {
        pk = dayDrinker6();
      }
      state.pack = pk || P().filter(function (p) { return p.qty === state.pack.qty; })[0] || P()[0];
      buildMedia(); renderThumbs(); renderSwatches(); renderTiers();
      var target = state.pack.key === 'single' ? colorIndex[state.color.id] : packIndex[state.pack.key];
      showMedia(target != null ? target : 0);
      preloadPack(state.pack);
      paint();
    });

    var addon = $('#addon');
    if (addon) {
      addon.checked = state.addon;
      addon.addEventListener('change', function () { state.addon = addon.checked; paint(); });
    }

    function addonProduct() { return D.addon || null; }

    // Packs are real products again: a pack tier adds the pack product itself,
    // so the charge is exactly the pack's own price and the per-unit figure is
    // display maths only. The single tier still charges the colour variant.
    function tierUnit(p) {
      if (p.qty > 1) return Math.round(p.price / p.qty);
      return state.color ? state.color.price : p.price;
    }
    function tierCharge(p) {
      return p.qty > 1 ? p.price : (state.color ? state.color.price : p.price);
    }

    // Packs ship as the fixed set shown in their photos; only the single
    // tier has a colour choice. The swatch row greys out on a pack and the
    // note below it says where custom mixes live (Build a Pack).
    function syncColourUI() {
      var isPack = state.pack.key !== 'single';
      var sw = $('#swatches');
      if (sw) sw.classList.toggle('sw-fixed', isPack);
      // The note stays visible either way; only its link wording changes,
      // since Single has no "own mix" to build (it already is one rubber).
      var link = $('#fixedset-link');
      if (link) {
        var wanted = isPack
          ? root.getAttribute('data-fixedset-link-pack')
          : root.getAttribute('data-fixedset-link-single');
        if (wanted) link.textContent = wanted;
      }
      var nameEl = $('#color-name');
      if (nameEl) {
        nameEl.textContent = isPack
          ? (root.getAttribute('data-fixedset-label') || 'set as shown')
          : state.color.name + (state.color.available ? '' : ' · sold out');
      }
    }

    function paint() {
      var p = state.pack;
      // Sitewide promo (see SITEWIDE_PCT up top): this is now the one price
      // this page leads with, not just the small per-unit label next to
      // each tier. p.compare is the real MSRP from Shopify (e.g. $77.99),
      // already wired below as the struck-through reference and the Save %
      // badge -- discounting charge here is the only change needed for both
      // of those to correctly show the full, bigger stacked savings instead
      // of just today's list-price markdown.
      var charge = Math.round(promoPrice(tierCharge(p)));
      syncColourUI();
      $('#price-now').textContent = money(charge);
      var s = $('#price-was');
      if (s) {
        if (p.compare > charge) { s.textContent = money(p.compare); s.style.display = ''; }
        else s.style.display = 'none';
      }
      var badge = $('#price-save');
      if (badge) {
        var pct = p.compare > charge ? Math.round((1 - charge / p.compare) * 100) : 0;
        if (pct > 0) { badge.textContent = 'Save ' + pct + '%'; badge.style.display = ''; }
        else badge.style.display = 'none';
      }

      var ap = addonProduct();
      // Shopify discounts each cart LINE independently, flooring on that
      // line's own total (price * qty), not on a single unit re-multiplied.
      // charge * state.qty re-multiplies an already-floored per-unit price
      // and can land a cent under what checkout actually charges once qty
      // is more than 1 (confirmed live: 2x this pack discounts to $82.49,
      // not 2 * $41.25 = $82.50). The addon is its own line too, and BR25OFF
      // applies to it as well ("items: all"), so it needs the same treatment
      // rather than being added at full price.
      var total = Math.round(promoPrice(tierCharge(p) * state.qty)) +
        (state.addon && ap ? Math.round(promoPrice(ap.price)) : 0);
      // The free-gift-unlocked message lives in the cart drawer's own
      // progress bar once something is actually added, so the button itself
      // stays short: long labels were forcing it onto two lines.
      var isPack = p.key !== 'single';
      var buyable = isPack || state.color.available;
      var atc = $('#atc');
      atc.textContent = buyable ? 'Add to cart · ' + money(total) : 'Sold out';
      atc.classList.toggle('disabled', !buyable);
      atc.disabled = !buyable;

      var sa = $('#sticky-atc');
      if (sa) sa.textContent = buyable ? 'Add · ' + money(total) : 'Sold out';
      var stt = $('#sticky-title');
      if (stt) stt.textContent = isPack ? p.title : p.title + ' · ' + state.color.name;

      // The page heading only ever changed on a format switch (bottle/can);
      // picking a different pack tier moved the price, image and note but
      // left the heading naming whichever tier the page had originally
      // loaded on. It needs to track state.pack on every paint, the same as
      // the sticky bar's title just above already does.
      var title = $('#pdp-title');
      if (title) title.textContent = isPack ? p.title : F().title;

      syncForms();
    }

    // Shopify's accelerated checkout buttons submit a real product form and a
    // payment button can only sell its own form's product. With packs being
    // real products there is one hidden form per wired product, keyed
    // "format-packKey"; only the active tier's form is shown and synced.
    function syncForms() {
      var key = state.format + '-' + state.pack.key;
      $$('[data-buyform]').forEach(function (wrap) {
        var active = wrap.getAttribute('data-buyform') === key;
        wrap.hidden = !active;
        if (!active) return;
        hydratePaymentButton(wrap);
        var v = wrap.querySelector('[data-form-variant]');
        var q = wrap.querySelector('[data-form-qty]');
        if (v) v.value = state.pack.key === 'single' ? state.color.variant : state.pack.variant;
        if (q) q.value = state.qty;
      });
    }

    function addToCart(e) {
      if (e) e.preventDefault();
      // A slow tap, or an impatient second tap while the first is still in
      // flight, used to fire two overlapping /cart/add.js requests — the
      // most common real cause of "could not be added": not a genuine
      // failure, just Shopify's cart getting two writes at once.
      if (Cart.busy) return;
      var p = state.pack;
      if (p.key === 'single' && !state.color.available) return;
      var lines = [];
      if (p.key === 'single') {
        lines.push({ id: state.color.variant, quantity: state.qty });
      } else {
        // The pack is a real product: one line, its own image and its exact
        // price. The assortment is fixed, so no colour property is needed.
        lines.push({ id: p.variant, quantity: state.qty });
      }
      var ap = addonProduct();
      if (state.addon && ap) lines.push({ id: ap.variant, quantity: 1 });

      Cart.busy = true;
      var btn = $('#atc');
      btn.classList.add('loading');
      Cart.add(lines)
        .then(function (res) {
          // A cart intervention (bundle app, validation function) can accept
          // the request yet add nothing: 200 with an empty items array. Say
          // so honestly instead of opening an empty drawer.
          if (res && res.items && res.items.length === 0) {
            throw new Error('That pack could not be added just now. Please try again, or use Build a Pack.');
          }
          return Cart.sync();
        })
        .then(function () { Drawer.open(); })
        .catch(function (err) { Toast.show(err.message, true); })
        .then(function () { Cart.busy = false; btn.classList.remove('loading'); });
    }
    var qtyInput = $('#qty-input');
    function setQty(n) {
      state.qty = Math.max(1, Math.min(99, n || 1));
      if (qtyInput) qtyInput.value = state.qty;
      paint();
    }
    $$('[data-qty-step]').forEach(function (b) {
      b.addEventListener('click', function () {
        setQty(state.qty + (+b.getAttribute('data-qty-step')));
      });
    });
    if (qtyInput) {
      qtyInput.addEventListener('input', function () {
        var n = parseInt(qtyInput.value.replace(/[^0-9]/g, ''), 10);
        state.qty = isNaN(n) ? 1 : Math.max(1, Math.min(99, n));
      });
      // Only normalise the field on blur, so typing "12" is not eaten after
      // the first keystroke.
      qtyInput.addEventListener('blur', function () { setQty(state.qty); });
    }

    $('#atc').addEventListener('click', addToCart);
    var st = $('#sticky-atc');
    if (st) st.addEventListener('click', addToCart);

    buildMedia(); renderThumbs(); renderSwatches(); renderTiers();
    var initialTarget = state.pack.key === 'single' ? colorIndex[state.color.id] : packIndex[state.pack.key];
    var targetIdx = initialTarget != null ? initialTarget : 0;
    var initialMedia = media[targetIdx];
    var ssrImg = stage.querySelector('img');
    // main-product.liquid already rendered this exact photo server-side for a
    // fast first paint (see stage_image there). The photo is the same one
    // JS is about to show here, just fetched at a different width param, so
    // treating this like any other showMedia() call would throw the
    // server's image away and download the same photo a second time. Only
    // sync the thumbnail/arrow chrome in that case; fall back to a normal
    // showMedia() whenever the two disagree on which photo it is.
    function baseName(url) { return url.split('?')[0].split('/').pop(); }
    var keptSsrImage = initialMedia && initialMedia.type !== 'video' && ssrImg &&
      baseName(ssrImg.src) === baseName(initialMedia.src);
    if (keptSsrImage) {
      syncMediaChrome(targetIdx);
    } else {
      showMedia(targetIdx);
    }
    preloadPack(state.pack, keptSsrImage ? initialMedia.src : null);
    paint();
    document.body.classList.add('has-sticky');
  }

  /* ---------------------------------------------------------- pack builder */
  function initBuilder() {
    var grid = $('#builder-grid');
    if (!grid) return;

    // Bottles and cans pool into one quantity, so 3 of each earns the 6 price.
    var picked = { bottle: {}, can: {} };
    var format = 'bottle';

    var PACKS = (D.formats.bottle.packs || []).map(function (p) {
      return { key: p.key, qty: p.qty, price: p.price };
    });
    if (!PACKS.length) return;

    function colors(f) { return (D.formats[f] && D.formats[f].colors) || []; }
    function totalFor(f) {
      return colors(f).reduce(function (s, c) { return s + (picked[f][c.id] || 0); }, 0);
    }
    function grandTotal() { return totalFor('bottle') + totalFor('can'); }

    function tierFor(n) {
      var best = PACKS[0];
      PACKS.forEach(function (p) { if (n >= p.qty) best = p; });
      return best;
    }
    // Same clamp as the buy box: Shopify hands out the best applicable
    // discount, so a rung can never cost more per unit than a smaller one.
    // Build a Pack adds loose rubbers, so what checkout charges is the single
    // price minus the "Pack pricing" discount for the quantity tier -- a fixed
    // US amount per rubber that Shopify converts to the shopper's currency and
    // rounds. In USD that equals pack price / qty; in AUD it does not (the
    // pack products are priced in whole dollars), so use the discount itself.
    function tierFlat(qty) {
      var usd = TIER_DISC[qty];
      return usd ? Math.round(usd * CUR_RATE) : null;
    }
    function unitFor(p) {
      var fl = tierFlat(p.qty);
      if (fl !== null && PACKS[0]) return PACKS[0].price - fl;
      var best = Math.round(p.price / p.qty);
      PACKS.forEach(function (o) {
        if (o.qty <= p.qty) best = Math.min(best, Math.round(o.price / o.qty));
      });
      return best;
    }
    // Promo'd unit price for a pack, rounded the same way paint() rounds
    // the one it displays -- shared so the "next rung" comparison and hint
    // below are never comparing a raw price against a promo'd one.
    function promoUnit(p) { return Math.round(promoPrice(unitFor(p))); }
    // Only offer the next rung if it genuinely costs less per rubber. Two rungs
    // can share a unit price, and promising a drop there would be a lie.
    function nextTier(n, unit) {
      for (var i = 0; i < PACKS.length; i++) {
        if (PACKS[i].qty > n && promoUnit(PACKS[i]) < unit) return PACKS[i];
      }
      return null;
    }

    function renderGrid() {
      grid.innerHTML = '';
      colors(format).forEach(function (c) {
        var n = picked[format][c.id] || 0;
        var card = el('div', 'bcard' + (n > 0 ? ' has' : ''));
        card.innerHTML =
          '<div class="bcard-imgwrap" data-c-img="' + esc(c.id) + '">' +
            '<img src="' + esc(c.thumb || c.img) + '" alt="' + esc(c.name) + '" loading="lazy" width="200" height="200">' +
            '<span class="bcard-zoom" aria-hidden="true"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="11" cy="11" r="7"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg></span>' +
          '</div>' +
          '<div class="nm">' + esc(c.name) + '</div>' +
          '<div class="qty">' +
            '<button type="button" data-c="' + esc(c.id) + '" data-d="-1" aria-label="Fewer"' +
              (n > 0 ? '' : ' class="off" aria-disabled="true"') + '>−</button>' +
            '<input type="text" inputmode="numeric" pattern="[0-9]*" autocomplete="off" data-n="' + esc(c.id) +
              '" value="' + n + '" aria-label="Quantity of ' + esc(c.name) + '"' + (c.available ? '' : ' disabled') + '>' +
            '<button type="button" data-c="' + esc(c.id) + '" data-d="1" aria-label="More"' +
              (c.available ? '' : ' disabled') + '>+</button>' +
          '</div>';
        grid.appendChild(card);
      });
    }

    function paint() {
      colors(format).forEach(function (c) {
        var n = $('[data-n="' + c.id + '"]');
        if (!n) return;
        var cnt = picked[format][c.id] || 0;
        // Never overwrite a field the shopper is typing in; it is
        // normalised when they leave it (see the change handler below).
        if (document.activeElement !== n) n.value = cnt;
        n.closest('.bcard').classList.toggle('has', cnt > 0);
        // A "-" at zero used to be a live button that did nothing, which
        // Clarity logged as dead clicks. It now reads as off (and stays
        // inert via the click handler) rather than looking tappable.
        var minus = n.closest('.bcard').querySelector('[data-d="-1"]');
        if (minus) {
          minus.classList.toggle('off', cnt === 0);
          minus.setAttribute('aria-disabled', String(cnt === 0));
        }
      });

      var nb = totalFor('bottle'), nc = totalFor('can'), n = nb + nc;
      var t = tierFor(n);

      // A pack that mixes bottles and cans cannot be a pack product, so it can
      // only be discounted by Shopify. Until those quantity discounts exist,
      // quote the single price rather than a total checkout will not honour.
      var mixed = nb > 0 && nc > 0;
      var poolable = !mixed || CFG.mixedDiscounts;

      // Sitewide promo (see SITEWIDE_PCT up top): applied to the bulk-tier
      // unit price here, same as the ladder below it, so "Price each" never
      // shows a different number than the rung it's actually sitting on.
      // full stays at the plain single price with neither discount, so
      // "You save" tells the full story -- bulk tier and sitewide promo
      // both -- same reasoning as the shop page's Save % badge comparing
      // against the real MSRP rather than just today's list price.
      var rawUnit = (n > 0 && poolable) ? unitFor(t) : PACKS[0].price;
      // Shopify discounts the whole cart LINE (rawUnit * n), not one unit
      // multiplied back out after rounding -- same fix as the product page's
      // paint(). Deriving total from n * (rounded unit) can land a cent or
      // more under what checkout actually charges once n grows past the
      // tier's own qty (confirmed live: 12 singles at the 12+ tier checks
      // out to $74.97, not 12 * $6.25 = $75.00). unit is then back-derived
      // from the correct total so the label and the total never disagree.
      var total = Math.round(promoPrice(rawUnit * n));
      var unit = n > 0 ? Math.round(total / n) : Math.round(promoPrice(rawUnit));
      var full = n * PACKS[0].price;

      $('#b-count').textContent = n;
      $('#b-unit').textContent = money(unit);
      $('#b-total').textContent = money(total);
      $('#b-saved').textContent = money(Math.max(0, full - total));
      $('#b-mix').innerHTML = n
        ? '<b>' + nb + '</b> for bottles · <b>' + nc + '</b> for cans'
        : 'Mix bottles and cans freely, they count together';

      var nx = nextTier(n, unit);
      $('#b-next').style.display = n ? '' : 'none';
      if (!n) {
        $('#b-next').innerHTML = '';
      } else if (!poolable) {
        $('#b-next').innerHTML = 'Mixed packs are <b>' + money(Math.round(promoPrice(PACKS[0].price))) + '</b> each. ' +
          'Keep your pack to bottles only, or cans only, to unlock pack pricing.';
      } else if (nx) {
        $('#b-next').innerHTML = 'Add <b>' + (nx.qty - n) + '</b> more to drop to <b>' +
          money(promoUnit(nx)) + '</b> each.';
      } else {
        $('#b-next').innerHTML = 'You are at the best price we do.';
      }

      var ship = $('#b-ship');
      ship.style.display = n ? '' : 'none';
      ship.innerHTML = total >= THRESHOLD
        ? (HAS_GIFT ? '✅ Free shipping and a free gift included' : '✅ Free shipping included')
        : 'Add <b>' + money(THRESHOLD - total) + '</b> more for free shipping' + (HAS_GIFT ? ' and a free gift' : '');

      $$('.rung').forEach(function (r) {
        r.classList.toggle('on', poolable && r.getAttribute('data-rung') === t.key && n > 0);
      });
      // Not a real [disabled] at zero: a disabled button swallows the tap
      // (.btn[disabled] has pointer-events:none, so the click lands on
      // whatever is underneath) and shoppers who hit "Add pack" before
      // picking anything got silence. It stays clickable, reads as
      // not-ready, and addPack() answers an empty tap with a nudge.
      $('#b-add').classList.toggle('is-empty', n === 0);
      $('#b-add').setAttribute('aria-disabled', String(n === 0));
      var stickyBtn = $('#b-add-sticky');
      if (stickyBtn) {
        stickyBtn.classList.toggle('is-empty', n === 0);
        stickyBtn.setAttribute('aria-disabled', String(n === 0));
        stickyBtn.textContent = n ? 'Add · ' + money(total) : 'Add pack';
      }
      var stickySub = $('#b-sticky-sub');
      if (stickySub) {
        var parts = [];
        if (nb) parts.push(nb + (nb === 1 ? ' bottle' : ' bottles'));
        if (nc) parts.push(nc + (nc === 1 ? ' can' : ' cans'));
        stickySub.textContent = parts.length ? parts.join(' + ') : '0 rubbers';
      }

      syncPaymentForm(nb, nc);
    }

    // Shopify's accelerated checkout buttons (Buy with Shop Pay, more
    // payment options) submit one real product form: one variant, one
    // quantity. They can only stand in for the build once it has collapsed
    // to a single color in a single format, where that form's variant and
    // quantity genuinely match what's in the picker. Any other mix hides
    // both forms rather than offer a shortcut that would check out the
    // wrong thing.
    function syncPaymentForm(nb, nc) {
      var forms = $$('[data-buyform]');
      if (!forms.length) return;
      var soloFormat = null, soloColor = null, soloQty = 0;
      if (nb > 0 && nc === 0) {
        var bIds = colors('bottle').filter(function (c) { return (picked.bottle[c.id] || 0) > 0; });
        if (bIds.length === 1) { soloFormat = 'bottle'; soloColor = bIds[0]; soloQty = picked.bottle[bIds[0].id]; }
      } else if (nc > 0 && nb === 0) {
        var cIds = colors('can').filter(function (c) { return (picked.can[c.id] || 0) > 0; });
        if (cIds.length === 1) { soloFormat = 'can'; soloColor = cIds[0]; soloQty = picked.can[cIds[0].id]; }
      }
      forms.forEach(function (wrap) {
        var active = soloFormat && wrap.getAttribute('data-buyform') === soloFormat;
        wrap.hidden = !active;
        if (!active) return;
        hydratePaymentButton(wrap);
        var v = wrap.querySelector('[data-form-variant]');
        var q = wrap.querySelector('[data-form-qty]');
        if (v) v.value = soloColor.variant;
        if (q) q.value = soloQty;
      });
    }

    /* ------------------------------------------------- pack gallery */
    // Slide 0 per format is the static hero collage (already in the markup).
    // Slides 1..N are one single-colour detail shot per colour, in the same
    // order as the colour selector, browsed with the prev/next arrows so a
    // shopper can see exactly what they're picking before adding it.
    var galHost = $('[data-bgal]');
    var galIndex = 0;

    var galDetail = {};
    try {
      var galEl = document.getElementById('bap-gallery-detail-data');
      if (galEl) galDetail = JSON.parse(galEl.textContent) || {};
    } catch (e) { galDetail = {}; }

    function galSlideCount(f) { return 1 + colors(f).length; }

    // Build the detail <img> elements once, for every format, up front --
    // cheaper than rebuilding on every format switch, and keeps the hero
    // images (already server-rendered for fast first paint) untouched.
    //
    // They carry data-src, not src: the images are stacked in one spot, so
    // loading="lazy" saw every one of them as on screen and fetched all 24
    // full-size PNGs on page load (about 1 MB, Lighthouse). galWarm() below
    // gives a slide its src only when it is showing or next to the one that
    // is. Requested at 800px wide; the gallery never shows them larger.
    function galSized(src) {
      return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=800';
    }
    if (galHost) {
      ['bottle', 'can'].forEach(function (f) {
        colors(f).forEach(function (c, i) {
          var src = (galDetail[f] && galDetail[f][c.id]) || c.img;
          if (!src) return;
          var im = document.createElement('img');
          im.setAttribute('data-src', galSized(src));
          im.alt = c.name + ' Beer Rubber';
          im.decoding = 'async';
          im.width = 900;
          im.height = 900;
          im.setAttribute('data-bgal-img', f);
          im.setAttribute('data-bgal-idx', String(i + 1));
          galHost.appendChild(im);
        });
      });
    }

    function galWarm(f, idx) {
      if (!galHost) return;
      var total = galSlideCount(f);
      [idx - 1, idx, idx + 1].forEach(function (k) {
        var want = (k + total) % total;
        if (want === 0) return; // slide 0 is the server-rendered hero
        var im = galHost.querySelector('[data-bgal-img="' + f + '"][data-bgal-idx="' + want + '"]');
        if (im && !im.getAttribute('src') && im.getAttribute('data-src')) im.src = im.getAttribute('data-src');
      });
    }

    function galShow(f, idx) {
      if (!galHost) return;
      $$('[data-bgal-img]', galHost).forEach(function (im) {
        var isHero = im.hasAttribute('data-bgal-hero');
        var imIdx = isHero ? 0 : (parseInt(im.getAttribute('data-bgal-idx'), 10) || 0);
        im.classList.toggle('on', im.getAttribute('data-bgal-img') === f && imIdx === idx);
      });
      var cap = $('[data-bgal-caption]', galHost);
      if (cap) {
        var activeColor = idx > 0 ? colors(f)[idx - 1] : null;
        cap.textContent = activeColor ? activeColor.name : '';
        cap.classList.toggle('on', !!activeColor);
      }
      galHost.classList.toggle('has-detail', colors(f).length > 0);
      galWarm(f, idx);
    }

    function syncGallery(f) {
      galIndex = 0;
      galShow(f, galIndex);
    }

    syncGallery(format);

    if (galHost) {
      var galPrev = $('[data-bgal-prev]', galHost), galNext = $('[data-bgal-next]', galHost);
      function galStep(dir) {
        var total = galSlideCount(format);
        galIndex = (galIndex + dir + total) % total;
        galShow(format, galIndex);
      }
      if (galPrev) galPrev.addEventListener('click', function () { galStep(-1); });
      if (galNext) galNext.addEventListener('click', function () { galStep(1); });
      // Tapping the photo itself used to do nothing (Clarity: dead clicks on
      // this header). Tap now moves to the next colour, like swiping a
      // carousel; the arrows still work and sit above the image.
      galHost.addEventListener('click', function (e) {
        if (e.target.closest('button')) return;
        galStep(1);
      });
    }

    renderFormats($('#builder-formats'), format, function (id) {
      format = id;
      renderGrid();
      syncGallery(format);
      paint();
    });

    /* ------------------------------------------------- swatch zoom preview */
    // Shoppers were tapping the small color photo expecting to see more of
    // it and nothing happened (the grid click handler only ever listened for
    // the +/- buttons). Tapping the photo now opens it full-size; tapping
    // anywhere on that preview (the photo, the backdrop, or the X) closes it,
    // so "click again to exit" is true no matter where they tap.
    var swzoom = null;
    function closeSwzoom() {
      if (!swzoom) return;
      swzoom.parentNode.removeChild(swzoom);
      swzoom = null;
      document.body.classList.remove('swzoom-open');
      document.removeEventListener('keydown', onSwzoomKey);
    }
    function onSwzoomKey(e) { if (e.key === 'Escape') closeSwzoom(); }
    function openSwzoom(c) {
      closeSwzoom();
      var src = (galDetail[format] && galDetail[format][c.id]) || c.img;
      swzoom = el('div', 'swzoom');
      swzoom.innerHTML =
        '<div class="swzoom-back"></div>' +
        '<div class="swzoom-card">' +
          '<button type="button" class="swzoom-x" aria-label="Close">&times;</button>' +
          '<img src="' + esc(src) + '" alt="' + esc(c.name) + ' Beer Rubber">' +
          '<div class="nm">' + esc(c.name) + '</div>' +
        '</div>';
      document.body.appendChild(swzoom);
      document.body.classList.add('swzoom-open');
      swzoom.addEventListener('click', closeSwzoom);
      document.addEventListener('keydown', onSwzoomKey);
    }

    // The number between - and + is a real field: shoppers kept tapping it
    // to type a quantity, so let them. Digits only; blank counts as 0 until
    // they leave the field, when it snaps back to the real number.
    grid.addEventListener('focusin', function (e) {
      if (e.target.matches && e.target.matches('input[data-n]')) {
        var f = e.target;
        setTimeout(function () { try { f.select(); } catch (err) {} }, 0);
      }
    });
    grid.addEventListener('input', function (e) {
      var f = e.target;
      if (!f.matches || !f.matches('input[data-n]')) return;
      var digits = f.value.replace(/\D/g, '').slice(0, 3);
      if (digits !== f.value) f.value = digits;
      var id = f.getAttribute('data-n');
      picked[format][id] = digits === '' ? 0 : parseInt(digits, 10);
      paint();
    });
    grid.addEventListener('change', function (e) {
      var f = e.target;
      if (!f.matches || !f.matches('input[data-n]')) return;
      f.value = picked[format][f.getAttribute('data-n')] || 0;
    });
    grid.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && e.target.matches && e.target.matches('input[data-n]')) e.target.blur();
    });

    grid.addEventListener('click', function (e) {
      if (e.target.closest('input[data-n]')) return;
      var b = e.target.closest('[data-c]');
      if (b) {
        if (b.disabled || b.classList.contains('off')) return;
        bump(b.getAttribute('data-c'), +b.getAttribute('data-d'));
        return;
      }
      var wrap = e.target.closest('.bcard-imgwrap');
      if (wrap) {
        var c = colors(format).filter(function (x) { return x.id === wrap.getAttribute('data-c-img'); })[0];
        if (c) openSwzoom(c);
        return;
      }
      // Tapping anywhere else on a colour card (its name, the blank space
      // around the stepper) used to do nothing -- shoppers read the whole
      // card as the button. It now adds one, same as the "+".
      var card = e.target.closest('.bcard');
      if (card) {
        var plus = card.querySelector('[data-d="1"]');
        if (plus && !plus.disabled) bump(plus.getAttribute('data-c'), 1);
      }
    });

    function bump(id, d) {
      picked[format][id] = Math.max(0, (picked[format][id] || 0) + d);
      paint();
      var num = $('[data-n="' + id + '"]');
      if (num) {
        num.classList.remove('pop');
        void num.offsetWidth;
        num.classList.add('pop');
      }
    }

    var ladder = $('#b-ladder');
    if (ladder) {
      PACKS.forEach(function (p) {
        var r = el('div', 'rung');
        r.setAttribute('data-rung', p.key);
        r.setAttribute('data-qty', p.qty);
        r.tabIndex = 0;
        r.setAttribute('role', 'button');
        // Sitewide promo display (see SITEWIDE_PCT above): the per-unit
        // price here is the real underlying product's price run through the
        // live sitewide %, same computation the shop page's tier list uses
        // on the same products, so a given quantity reads identically on
        // both pages. The threshold flag uses that same post-promo total,
        // since that's what the cart will actually show as qualifying.
        var rungRaw = unitFor(p) * p.qty;
        var rungTotal = SITEWIDE_PCT ? promoPrice(rungRaw) : rungRaw;
        var rungUnit = Math.round(rungTotal / p.qty);
        var badge = rungTotal >= THRESHOLD ? ' <span class="r-free">' + (HAS_GIFT ? 'Free Shipping + Gift' : 'Free Shipping') + '</span>' : '';
        r.innerHTML = '<span>' + p.qty + (p.qty === 1 ? ' rubber' : ' rubbers') + badge + '</span>' +
          '<span class="r-price">' + money(rungUnit) + ' each</span>';
        ladder.appendChild(r);
      });

      // The ladder above is a reference chart, not a picker, but it's
      // styled close enough to the shop page's clickable pack tiers that
      // shoppers try to tap a rung expecting a selection to happen. Rather
      // than leave that tap looking dead, point it at the color grid --
      // where building toward that price actually happens -- same format
      // whether bottles or cans are showing, since this only targets the
      // grid container itself, not its contents.
      var gridTip = $('#builder-grid-tip');
      var tipTimer = null;
      function pointAtGrid(qty) {
        var grid = $('#builder-grid');
        if (!grid) return;
        if (gridTip) {
          clearTimeout(tipTimer);
          gridTip.textContent = 'Pick any ' + qty + ' and above colors to hit this price.';
          gridTip.classList.add('show');
          tipTimer = setTimeout(function () { gridTip.classList.remove('show'); }, 3200);
        }
        // Centering the grid itself can push the tip -- which sits just
        // above it -- off the top of a short phone screen, since the grid
        // is tall enough on its own to fill most of the viewport. Aligning
        // the tip to the top instead keeps it, and the first row of colors
        // right under it, both in view together.
        (gridTip || grid).scrollIntoView({ behavior: 'smooth', block: 'start' });
        grid.classList.remove('grid-glow');
        void grid.offsetWidth;
        grid.classList.add('grid-glow');
      }
      ladder.addEventListener('click', function (e) {
        var r = e.target.closest('.rung');
        if (r) pointAtGrid(r.getAttribute('data-qty'));
      });
      ladder.addEventListener('keydown', function (e) {
        if (e.key !== 'Enter' && e.key !== ' ') return;
        var r = e.target.closest('.rung');
        if (!r) return;
        e.preventDefault();
        pointAtGrid(r.getAttribute('data-qty'));
      });
    }

    // Shared by an empty "Add pack" tap and the tappable shipping/next-tier
    // lines: bring the colour grid into view with a short instruction so the
    // tap always visibly does something.
    var nudgeTimer = null;
    function nudgeToGrid(msg) {
      var g = $('#builder-grid');
      var tip = $('#builder-grid-tip');
      if (!g) return;
      if (tip) {
        clearTimeout(nudgeTimer);
        tip.textContent = msg;
        tip.classList.add('show');
        nudgeTimer = setTimeout(function () { tip.classList.remove('show'); }, 3200);
      }
      (tip || g).scrollIntoView({ behavior: 'smooth', block: 'start' });
      g.classList.remove('grid-glow');
      void g.offsetWidth;
      g.classList.add('grid-glow');
    }
    ['#b-ship', '#b-next'].forEach(function (sel) {
      var node = $(sel);
      if (node) node.addEventListener('click', function () {
        nudgeToGrid('Add more colors here to unlock the next price.');
      });
    });

    function addPack() {
      var n = grandTotal();
      if (!n) { nudgeToGrid('Pick at least 1 rubber to start your pack.'); return; }
      if (Cart.busy) return;
      var lines = [];

      // Every build goes in as individual colour variants: the bundle-app
      // pack parents cannot be added directly, and singles keep colour-level
      // inventory honest. The Shopify quantity discounts price the pack.
      // The property text is static (not the rubber count): Shopify keys a
      // cart line by variant + properties together, so a changing count here
      // stopped a second build-a-pack add from merging into the shopper's
      // existing lines at all, it created a whole new duplicate set instead
      // (e.g. adding one more can after an earlier add re-added the bottles
      // too, as a second copy alongside the first).
      ['bottle', 'can'].forEach(function (f) {
        colors(f).forEach(function (c) {
          var q = picked[f][c.id] || 0;
          if (q > 0) lines.push({ id: c.variant, quantity: q, properties: { 'Pack': 'Build your own pack' } });
        });
      });

      Cart.busy = true;
      var btns = [$('#b-add'), $('#b-add-sticky')].filter(Boolean);
      btns.forEach(function (b) { b.disabled = true; });
      Cart.add(lines)
        .then(Cart.sync)
        .then(function () {
          // Clear the picker only once the add has actually succeeded, so a
          // shopper who comes back to add one more color starts from zero
          // instead of the whole prior build being re-submitted alongside
          // it. A failed add leaves the picker untouched, nothing to redo.
          picked = { bottle: {}, can: {} };
          renderGrid();
          paint();
          Drawer.open();
        })
        .catch(function (err) { Toast.show(err.message, true); })
        .then(function () { Cart.busy = false; btns.forEach(function (b) { b.disabled = false; }); });
    }

    $('#b-add').addEventListener('click', addPack);
    var stickyAddBtn = $('#b-add-sticky');
    if (stickyAddBtn) stickyAddBtn.addEventListener('click', addPack);
    document.body.classList.add('has-sticky');

    renderGrid();
    paint();
  }

  /* ---------------------------------------------------------------- FAQ */
  function initFaq() {
    $$('.q > button').forEach(function (b) {
      b.addEventListener('click', function () {
        var q = b.parentElement;
        var open = q.classList.contains('open');
        q.classList.toggle('open', !open);
        b.setAttribute('aria-expanded', String(!open));
      });
    });
  }

  /* ------------------------------------------------------------ video strip */
  function initVideoStrip() {
    $$('.vcard').forEach(function (card) {
      card.addEventListener('click', function () {
        var src = card.getAttribute('data-video');
        if (!src || card.classList.contains('playing')) return;
        card.classList.add('playing');
        card.innerHTML = '<video src="' + esc(src) + '" controls autoplay playsinline></video>';
      });
    });
  }

  /* --------------------------------------------------------- countdown bar */
  function initCountdown() {
    var bar = $('[data-countdown-bar]');
    if (!bar) return;
    var end = new Date(bar.getAttribute('data-end')).getTime();
    if (!end || isNaN(end)) return;

    var daysWrap = bar.querySelector('[data-cd-days-wrap]');
    var elDays = bar.querySelector('[data-cd-days]');
    var elHrs = bar.querySelector('[data-cd-hrs]');
    var elMins = bar.querySelector('[data-cd-mins]');
    var elSecs = bar.querySelector('[data-cd-secs]');

    function pad(n) { return String(n).length < 2 ? '0' + n : String(n); }

    function tick() {
      var diff = end - Date.now();
      // The Liquid render already hid this bar for anyone whose page loads
      // after the end time; this covers the shopper already on the page
      // when the clock runs out mid-visit, so it disappears without a
      // refresh instead of sitting at 00:00:00.
      if (diff <= 0) { bar.remove(); return; }
      var days = Math.floor(diff / 86400000);
      var hrs = Math.floor((diff % 86400000) / 3600000);
      var mins = Math.floor((diff % 3600000) / 60000);
      var secs = Math.floor((diff % 60000) / 1000);
      if (daysWrap) daysWrap.style.display = days > 0 ? '' : 'none';
      elDays.textContent = pad(days);
      elHrs.textContent = pad(hrs);
      elMins.textContent = pad(mins);
      elSecs.textContent = pad(secs);
    }

    tick();
    setInterval(tick, 1000);
  }

  /* -------------------------------------- sound toggle on autoplay videos */
  function initSoundToggles() {
    $$('.sound-toggle-wrap').forEach(function (wrap) {
      var video = wrap.querySelector('video');
      var btn = wrap.querySelector('[data-sound-toggle]');
      if (!video || !btn) return;
      function sync() {
        btn.classList.toggle('sound-on', !video.muted);
        btn.setAttribute('aria-label', video.muted ? 'Unmute video' : 'Mute video');
      }
      function toggle(e) {
        if (e) e.stopPropagation();
        video.muted = !video.muted;
        if (!video.muted) video.play().catch(function () {});
        sync();
      }
      btn.addEventListener('click', toggle);
      // Clicking the video itself also toggles sound, matching how a
      // shopper naturally tries to interact with a playing video.
      video.addEventListener('click', toggle);
      sync();
    });

    // Pausing off-screen autoplay videos keeps two decoders from ever
    // running at once on a long scroll, which is kinder to phone memory
    // than letting every autoplay video on the page decode simultaneously.
    if ('IntersectionObserver' in window) {
      var vids = $$('.sound-toggle-wrap video');
      if (vids.length) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var v = entry.target;
            if (entry.isIntersecting) {
              // Browsers can silently refuse to resume an unmuted video
              // from a scroll-triggered (not a direct click) play() call.
              // Rather than leave it frozen with the speaker still showing
              // "on", fall back to a muted resume so playback never just
              // silently stops.
              v.play().catch(function () {
                if (!v.muted) {
                  v.muted = true;
                  var wrap = v.closest('.sound-toggle-wrap');
                  var btn = wrap && wrap.querySelector('[data-sound-toggle]');
                  if (btn) {
                    btn.classList.remove('sound-on');
                    btn.setAttribute('aria-label', 'Unmute video');
                  }
                  v.play().catch(function () {});
                }
              });
            } else {
              v.pause();
            }
          });
        }, { threshold: 0.25 });
        vids.forEach(function (v) { io.observe(v); });
      }
    }
  }

  /* ------------------------------------------------- contact form anti-spam */
  function initContact() {
    var form = $('#contact-form');
    if (!form) return;
    var loadedAt = Date.now();
    form.addEventListener('submit', function (e) {
      var hp = form.querySelector('[name="contact[website]"]');
      var tooFast = Date.now() - loadedAt < 3000;
      if ((hp && hp.value) || tooFast) {
        // Bots get a success screen so they stop retrying. Nothing is sent.
        e.preventDefault();
        form.innerHTML = '<div class="notice">Thanks. Your message is on its way, we reply within one business day.</div>';
      }
    });
  }

  /* ----------------------------------------------- lazy video posters */
  // Video cards keep their poster in data-poster and only get it when the
  // card is within a few screens of the viewport, so the review videos far
  // down a page do not compete with the photos at the top.
  function initLazyPosters() {
    var vids = $$('video[data-poster]');
    if (!vids.length) return;
    function give(v) { v.setAttribute('poster', v.getAttribute('data-poster')); v.removeAttribute('data-poster'); }
    if (!('IntersectionObserver' in window)) { vids.forEach(give); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting && e.target.hasAttribute('data-poster')) { give(e.target); io.unobserve(e.target); }
      });
    }, { rootMargin: '900px 0px' });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ------------------------------------------- build a pack "pick colors" cue */
  // The pill on the gallery (phones only) scrolls to the colour picker, and
  // fades out once the shopper has scrolled on their own.
  function initBapCue() {
    var cue = $('[data-bap-cue]');
    if (!cue) return;
    cue.addEventListener('click', function () {
      var t = $('#builder-formats');
      if (!t) return;
      var hdr = $('.header');
      var y = t.getBoundingClientRect().top + window.pageYOffset - (hdr ? hdr.offsetHeight : 0) - 12;
      var calm = window.matchMedia && window.matchMedia('(prefers-reduced-motion:reduce)').matches;
      window.scrollTo({ top: y, behavior: calm ? 'auto' : 'smooth' });
    });
    function fade() { cue.classList.toggle('gone', window.pageYOffset > 60); }
    window.addEventListener('scroll', fade, { passive: true });
    fade();
  }

  /* ----------------------------------------------------- welcome popup */
  // Corner card from sections/br-popup.liquid. Opens after a delay (or on
  // desktop exit intent). Once the visitor closes it or signs up it never
  // opens for them again (localStorage plus a one-year cookie). The sign-up
  // is a normal form post, because Shopify attaches its CAPTCHA token on that
  // submit; Shopify then returns the visitor to this page with
  // ?customer_posted=true, and the popup reopens on its success view.
  function initPopup() {
    var pop = $('[data-brpop]');
    if (!pop) return;
    var KEY = 'br_welcome_done';
    var design = pop.getAttribute('data-design') === 'true';
    var formWrap = $('[data-brpop-form]', pop);
    var doneWrap = $('[data-brpop-done]', pop);
    var form = $('form', pop);
    var opened = false;

    function remember() {
      try { localStorage.setItem(KEY, '1'); } catch (e) {}
      try { document.cookie = 'br_welcome=1;path=/;max-age=31536000;SameSite=Lax'; } catch (e) {}
    }
    function seen() {
      try { if (localStorage.getItem(KEY)) return true; } catch (e) {}
      return /(?:^|;\s*)br_welcome=1/.test(document.cookie);
    }

    // Back from Shopify after a sign-up: tidy the address bar.
    var posted = /[?&]customer_posted=true/.test(location.search);
    if (posted || /[?&]form_type=customer/.test(location.search)) {
      try {
        var u = new URL(location.href);
        ['customer_posted', 'form_type', 'utf8', 'contact[tags]', 'contact[email]'].forEach(function (k) { u.searchParams.delete(k); });
        history.replaceState(null, '', u.pathname + u.search);
      } catch (e) {}
    }

    // On phones the corner card is full width at the bottom, so lift it
    // above a sticky Add to cart bar if one is showing.
    function lift() {
      var bar = $('.sticky-atc');
      var h = 0;
      if (bar && getComputedStyle(bar).display !== 'none') h = bar.offsetHeight;
      pop.style.setProperty('--pop-lift', h + 'px');
    }

    function open(force) {
      if (opened || (!force && !design && seen())) return;
      // a drawer, gift picker or zoom viewer is open: try again shortly
      if (!force && (document.body.classList.contains('no-scroll') || $('.swzoom') || $('.giftmodal'))) {
        setTimeout(open, 4000);
        return;
      }
      opened = true;
      lift();
      pop.hidden = false;
      requestAnimationFrame(function () { requestAnimationFrame(function () { pop.classList.add('on'); }); });
    }

    function close() {
      pop.classList.remove('on');
      remember();
      setTimeout(function () { pop.hidden = true; }, 350);
    }

    pop.addEventListener('click', function (e) {
      if (e.target.closest('[data-brpop-close]')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && pop.classList.contains('on')) close();
    });
    window.addEventListener('resize', function () { if (opened) lift(); });

    if (posted) {
      remember();
      formWrap.hidden = true;
      doneWrap.hidden = false;
      open(true);
      var cb = $('[data-brpop-copy]', pop);
      if (cb) cb.focus({ preventScroll: true });
    } else if ($('.brpop-err', pop)) {
      open(true);
      $('#brpop-email', pop).focus({ preventScroll: true });
    } else {
      var delay = Math.max(0, +pop.getAttribute('data-delay') || 0);
      setTimeout(open, design ? 800 : delay * 1000);

      // desktop only: cursor leaves through the top of the window
      if (pop.getAttribute('data-exit') === 'true' && window.matchMedia('(hover:hover) and (pointer:fine)').matches) {
        var armed = false;
        setTimeout(function () { armed = true; }, 3000);
        document.addEventListener('mouseout', function (e) {
          if (armed && !e.relatedTarget && e.clientY <= 0) open();
        });
      }
    }

    // copy the code
    pop.addEventListener('click', function (e) {
      var c = e.target.closest('[data-brpop-copy]');
      if (!c) return;
      var hint = $('[data-brpop-hint]', pop);
      function done() { if (hint) hint.textContent = 'Copied. It is also applied if you tap Shop now.'; }
      function manual() { if (hint) hint.textContent = 'Press and hold the code to copy it.'; }
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(c.getAttribute('data-code')).then(done, manual);
      } else {
        manual();
      }
    });
  }

  /* ------------------------------------------------------------------ boot */
  function boot() {
    Drawer.build();
    initProduct();
    initBuilder();
    initFaq();
    initVideoStrip();
    initSoundToggles();
    initCountdown();
    initContact();
    initPopup();
    initBapCue();
    initLazyPosters();

    var burger = $('#burger');
    var mobilenav = $('#mobilenav');
    if (burger && mobilenav) {
      burger.addEventListener('click', function () {
        var open = mobilenav.classList.toggle('open');
        // `hidden` keeps the drawer out of the accessibility tree when shut,
        // which a display:none class alone does not guarantee across browsers.
        mobilenav.hidden = !open;
        burger.setAttribute('aria-expanded', String(open));
        burger.textContent = open ? '✕' : '☰';
      });
    }

    Cart.fetch().then(function () {
      // pre-check shipping protection on the first cart that has real items
      var wants = true;
      try { wants = localStorage.getItem('br-protect') !== '0'; } catch (e) {}
      if (wants && CFG.protectionDefault && D.protection && Cart.state.item_count > 0 && !Cart.findLine(isProtectionLine)) {
        return Cart.setProtection(true).then(Cart.sync);
      }
      return Cart.sync();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  window.BR = { Cart: Cart, Drawer: Drawer, money: money };
})();
